module.exports = __webpack_public_path__ + "media/images/Kitchen Espresso Cabinets-eb1d84fc.jpg";